import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { ParcelDimensions } from '../../../models/shipmentCountryInfo';
import { useStore } from '../../../stores/store';
import { isObjectsEqual } from '../../../utils/generic/generic.utils';
import { DimensionsFormValues } from './parcel-details-dimensions.component';

const ChangeHandler = () => {
  const { values, initialValues, validateForm, setFieldValue } =
    useFormikContext<DimensionsFormValues>();
  const {
    parcelCreationStore: {
      parcelDimensions,
      resetShipmentDataInCaseDeliveryDetailsChanged,
      prefillInProgress,
      setParcelDimensions,
      deliveryLimitations,
    },
  } = useStore();

  useEffect(() => {
    const currentScrollY = window.scrollY;

    const newDimensions: ParcelDimensions = Object.entries(values).reduce(
      (acc, [key, value]) => {
        acc[key as keyof DimensionsFormValues] =
          typeof value === 'string' ? parseFloat(value) || 0 : value;
        return acc;
      },
      {} as ParcelDimensions
    );
    if (!isObjectsEqual(newDimensions, parcelDimensions)) {
      setParcelDimensions(newDimensions);
      resetShipmentDataInCaseDeliveryDetailsChanged();

      window.requestAnimationFrame(() => {
        window.scrollTo(0, currentScrollY);
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setParcelDimensions, values]);

  useEffect(() => {
    validateForm();
  }, [deliveryLimitations, validateForm]);

  // Required for draft editing case,
  // because parcelDimensions are set after form is rendered with init values
  useEffect(() => {
    if (prefillInProgress) return;

    if (!initialValues.size_x && parcelDimensions?.size_x) {
      setFieldValue('size_x', parcelDimensions?.size_x);
    }

    if (!initialValues.size_z && parcelDimensions?.size_z) {
      setFieldValue('size_z', parcelDimensions?.size_z);
    }

    if (!initialValues.size_y && parcelDimensions?.size_y) {
      setFieldValue('size_y', parcelDimensions?.size_y);
    }

    if (!initialValues.weight && parcelDimensions?.weight) {
      setFieldValue('weight', parcelDimensions?.weight);
    }
  }, [prefillInProgress, initialValues, setFieldValue, parcelDimensions]);

  return null;
};

export default observer(ChangeHandler);
